import Seo from "../components/Seo";
import Section from "../components/ui-custom/Section";
import ContactForm from "../components/sections/ContactForm";
import FAQ from "../components/sections/FAQ";
import PageHeader from "../components/ui-custom/PageHeader";
import { Reveal } from "../components/ui-custom/Reveal";
import Icon from "../components/Icon";

const cards = [
  { icon: "BookOpen", title: "Knowledge Base", desc: "Step-by-step guides for every service and workflow." },
  { icon: "MessageCircle", title: "Live Chat", desc: "Chat with our support team 24x7, any day of the year." },
  { icon: "Phone", title: "Call Support", desc: "Talk to a human. Dedicated managers for enterprise clients." },
];

export default function Support() {
  return (
    <>
      <Seo title="Support" description="Get help from the utipanagecy support team — knowledge base, live chat and 24x7 phone support." />
      <PageHeader eyebrow="Support" title="We're here 24x7" sub="Find answers, chat with us, or send a message — help is always a click away." />
      <Section testId="support-page">
        <div className="grid gap-5 sm:grid-cols-3">
          {cards.map((c, i) => (
            <Reveal key={c.title} delay={i * 0.08}>
              <div className="h-full rounded-3xl glass p-7 text-center" data-testid={`support-card-${i}`}>
                <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-2xl bg-brand-soft text-brand">
                  <Icon name={c.icon} size={22} />
                </div>
                <h3 className="mt-5 font-semibold text-slate-900">{c.title}</h3>
                <p className="mt-2 text-sm text-slate-500">{c.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </Section>
      <Section eyebrow="Get in touch" heading="Send us a message" center testId="support-contact">
        <ContactForm />
      </Section>
      <Section eyebrow="FAQ" heading="Common questions" center testId="support-faq">
        <FAQ />
      </Section>
    </>
  );
}
